import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { CheckCircle2 } from 'lucide-react';
const initiatives = ['Supply Chain Resilience Framework Implementation', 'AI-Driven Logistics Forecasting Model', 'Cross-Border Regulatory Compliance Overhaul', 'Sustainable Fleet Modernization Program', 'Executive Leadership Mentorship Pipeline', 'Cybersecurity Protocol for Classified Logistics'];
export function StrategySection() {
  return <Section id="strategy" variant="charcoal" data-id="element-363">
      <SectionHeader title="Strategic Initiatives" subtitle="Forward Operations" data-id="element-364" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-365">
        {initiatives.map((item, index) => <Reveal key={index} delay={index * 50} data-id="element-366">
            <div className="flex items-center p-4 bg-navy-900 border border-white/5 hover:border-gold-500/30 transition-colors rounded-sm" data-id="element-367">
              <CheckCircle2 className="text-gold-500 w-6 h-6 mr-4 flex-shrink-0" data-id="element-368" />
              <span className="text-lg text-white font-medium" data-id="element-369">{item}</span>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}